import React, { useEffect, useState } from "react";
import HorizontalGridList from "components/HorizontalGridList";
import api from "../api";
import { makeStyles } from "@mui/styles";
import ModalGrid from "components/ModalGrid";
import CollapsibleDataTable from "components/CollapsibleDataTable";

const useStyles = makeStyles((theme) => ({
  mainSection: {
    width: "100%",
    marginTop: theme.spacing(2),
  },
}));

const Schedules = () => {
  const classes = useStyles();

  // Sources and Current Source index
  const [subLink, setSubLink] = useState(-1);
  const [sources, setSources] = useState([]);
  const [fieldDetails, setFieldDetails] = useState(null);

  //ALL Set Schedules
  const [allSchedules, setAllSchedules] = useState([]);

  //TICKERS AND ENGINES
  const [tickers, setTickers] = useState([]);
  const [enrichSources, setEnrichSources] = useState([]);
  const [transferSources, setTransferSources] = useState([]);

  // Refresh
  const [refresh, setRefresh] = useState(true);
  const [openRows, setOpenRows] = useState({});

  // On Did Mount
  useEffect(() => {
    api.getPullSources().then((data) => {
      setSources(data);
      setSubLink(0);
    });

    api.available_tickers("ABCD12345").then((data) => {
      setTickers(data);
    });
  }, []);

  useEffect(() => {
    // FETCH NEW META DATA FOR SOURCE
    setFieldDetails(null);
    setOpenRows({
      schedules: {},
    });

    if (subLink >= 0) {
      // GET META DATA FOR CURRENT DATA SOURCE
      api.meta(sources[subLink].key).then((data) => {
        setFieldDetails(data);
      });
    }
  }, [sources, subLink]);

  // On Update sources subLink Refresh
  useEffect(() => {
    //Table clears first then updates for new source
    setAllSchedules([]);

    if (subLink >= 0) {
      api
        .get_schedules("ABCD12345", sources[subLink].key)
        .then((data) => {
          setAllSchedules(data);
        })
        .catch((err) => {
          console.log(err);
        });

      // GET Enrichment sources and etc.
      setEnrichSources(sources[subLink]["enrichment_sources"]);
      setTransferSources(sources[subLink]["transfer_sources"]);
    }
  }, [sources, subLink, refresh]);

  return (
    <>
      {subLink >= 0 && fieldDetails ? (
        <>
          <HorizontalGridList
            subLink={subLink}
            setSubLink={setSubLink}
            sources={sources}
          />

          <h1>{sources[subLink].name}</h1>

          <div className={classes.mainSection}>
            <ModalGrid
              source={sources[subLink]}
              setRefresh={setRefresh}
              formOptions={{
                ticker: tickers,
                enrichment_sources: enrichSources,
                transfer_sources: transferSources,
              }}
              formFields={fieldDetails["schedule"]["formFields"]}
              combined
              schedule
              submitButton={api.create_schedule}
            />

            <CollapsibleDataTable
              source={sources[subLink]}
              tableData={unRollData(allSchedules)}
              setRefresh={setRefresh}
              innerSet="pulljob_set"
              outerTableFields={fieldDetails["schedule"]["outerTableFields"]}
              innerTableFields={fieldDetails["schedule"]["tableFields"]}
              deleteFunc={api.disable_schedule}
              schedule
              type="schedules"
              openRows={openRows}
              setOpenRows={setOpenRows}
            />
          </div>
        </>
      ) : (
        <h1>Loading</h1>
      )}
    </>
  );
};

const unRollData = (allSchedules) => {
  let schedules = [];

  allSchedules.forEach((element) => {
    // UNROLL ALL PULLJOB_SET
    element["pulljob_set"] = [];
    element["jobs"].forEach((job) => {
      element["pulljob_set"] = element["pulljob_set"].concat(
        job["pulljob_set"]
      );
    });
    // UNROLL PERIODIC_TASK
    let scheduleObj = { ...element, ...element["periodic_task"]["args"][0] };

    // console.log(scheduleObj);
    schedules.push(scheduleObj);
  });
  return schedules;
};

export default Schedules;
